import { render, staticRenderFns } from "./AddressSelect.vue?vue&type=template&id=02e89a09&scoped=true"
import script from "./AddressSelect.vue?vue&type=script&lang=js"
export * from "./AddressSelect.vue?vue&type=script&lang=js"
import style0 from "./AddressSelect.vue?vue&type=style&index=0&id=02e89a09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e89a09",
  null
  
)

export default component.exports